import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  addNewSegmentButtonAltText: {
    id: 'course-authoring.grading-settings.add-new-segment.btn.text',
    defaultMessage: 'Add new grading segment',
  },
  removeSegmentButtonText: {
    id: 'course-authoring.grading-settings.remove-segment.btn.text',
    defaultMessage: 'Remove',
  },
  segmentFailGradingText: {
    id: 'course-authoring.grading-settings.fail-segment.text',
    defaultMessage: 'Fail',
  },
  defaultPassText: {
    id: 'course-authoring.grading-settings.default.pass.text',
    defaultMessage: 'Pass',
  },
});

export default messages;
